import { ScopeSummary } from 'src/stores/scopes-store';
import DataStoreMock from './base/data-store';
import { Query } from '@testing-library/react';
import { ScopeSummaryMockData } from '../data-sources/scope-summary';

export class ScopeSummaryStoreMock extends DataStoreMock<ScopeSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: ScopeSummaryMockData,
      count: ScopeSummaryMockData.length,
    });
    return true;
  }

  public async getData(query: Partial<Query>) {
    return ScopeSummaryMockData;
  }
}
